import { ObjectValues } from 'helpers/types';

export const FOR_BANK_SECTIONS = {
  OVERVIEW: 'FOR_BANK_OVERVIEW',
  EXECUTIVE_SUMMARY: 'FOR_BANK_EXECUTIVE_SUMMARY',
  ABOUT_COMPANY: 'FOR_BANK_ABOUT_COMPANY',
  PRODUCTS_AND_SERVICES: 'FOR_BANK_PRODUCTS_AND_SERVICES',
  MARKET_ANALYSIS: 'FOR_BANK_MARKET_ANALYSIS',
  MARKETING_AND_SALES: 'FOR_BANK_MARKETING_AND_SALES',
  BUSINESS_OPERATIONS: 'FOR_BANK_BUSINESS_OPERATIONS',
  MANAGEMENT_AND_ORGANIZATION: 'FOR_BANK_MANAGEMENT_AND_ORGANIZATION',
  IMPLEMENTATION_PLAN: 'FOR_BANK_IMPLEMENTATION_PLAN',
  RAISING_AND_ALLOCATING_FUNDS: 'FOR_BANK_RAISING_AND_ALLOCATING_FUNDS',
  LEGAL_FRAMEWORKS_AND_RISKS: 'FOR_BANK_LEGAL_FRAMEWORKS_AND_RISKS',
  FINANCIAL_PLAN: 'FOR_BANK_FINANCIAL_PLAN',
} as const;

export type IForBankSections = ObjectValues<typeof FOR_BANK_SECTIONS>;

export const FOR_BANK_SUB_SECTIONS = {
  [FOR_BANK_SECTIONS.OVERVIEW]: {
    COMPANY: 'company',
    PROJECT: 'project',
    MARKET_CUSTOMERS: 'marketAndCustomers',
    FINANCIAL_INFO: 'financialInfo',
    FUNDING_NEEDS: 'fundingNeeds',
  },
  [FOR_BANK_SECTIONS.EXECUTIVE_SUMMARY]: {
    GOALS_AND_OBJECTIVES: 'goalsAndObjectives',
    COMPANY_DESCRIPTION: 'companyDescription',
    PRODUCTS_OR_SERVICES: 'productsOrServices',
    MARKET_AND_CUSTOMERS: 'marketAndCustomers',
    ORGANIZATION_AND_TEAM: 'organizationAndTeam',
    FINANCIAL_INFORMATION: 'financialInformation',
    FINANCING_NEEDS: 'financingNeeds',
    RISKS: 'risks',
  },
  [FOR_BANK_SECTIONS.ABOUT_COMPANY]: {
    GENERAL_INFO: 'generalInfo',
    COMPANY_HISTORY: 'companyHistory',
    MISSION_AND_STRATEGY: 'missionAndStrategy',
    SWOT: 'swot',
  },
  [FOR_BANK_SECTIONS.PRODUCTS_AND_SERVICES]: {
    DESCRIPTION: 'description',
    ADVANTAGES: 'advantages',
    R_AND_D: 'randd',
    DELIVERY_AND_SUPPORT: 'deliveryAndSupport',
  },
  [FOR_BANK_SECTIONS.MARKET_ANALYSIS]: {
    MARKET_OVERVIEW: 'marketOverview',
    COMPETITIVE_ANALYSIS: 'competitiveAnalysis',
    CONSUMER_NEEDS: 'consumerNeeds',
  },
  [FOR_BANK_SECTIONS.MARKETING_AND_SALES]: {
    SALES_PLAN: 'salesPlan',
    MARKETING_PLAN: 'marketingPlan',
  },
  [FOR_BANK_SECTIONS.BUSINESS_OPERATIONS]: {
    LOCATION_AND_PREMISES: 'locationAndPremises',
    EQUIPMENT: 'equipment',
    ASSETS: 'otherAssets',
    TECHNOLOGICAL_PROCESS: 'technologicalProcess',
    WORKING_RESOURCES: 'workingResources',
    PARTNERS: 'partnersSection',
    PRODUCTION: 'production',
    QUALITY: 'quality',
  },
  [FOR_BANK_SECTIONS.MANAGEMENT_AND_ORGANIZATION]: {
    MANAGEMENT_TEAM: 'managementTeam',
    EXTERNAL_PARTNERS_AND_ADVISERS: 'externalPartnersAndAdvisers',
    STAFF_ORGANIZATION: 'staffOrganization',
  },
  [FOR_BANK_SECTIONS.FINANCIAL_PLAN]: {
    KEY_ASSUMPTIONS: 'keyAssumptions',
    REVENUE_PLAN: 'revenuePlan',
    PLANNED_EXPENSES: 'plannedExpenses',
    PROFIT_AND_LOSS_PROJECTION: 'profitAndLossProjection',
    CASH_FLOW_ELEMENTS: 'cashFlowElements',
    FINANCIAL_PERFORMANCE: 'financialPerformance',
    OPENING_BALANCE_SHEETS: 'openingBalanceSheets',
    PROJECTED_BALANCE_SHEETS: 'projectedBalanceSheets',
    PROJECTED_CASH_FLOW: 'projectedCashFlow',
  },
} as const;

export type IForBankOverviewSubSections = ObjectValues<typeof FOR_BANK_SUB_SECTIONS.FOR_BANK_OVERVIEW>;
export type IForBankExecutiveSummarySubSections = ObjectValues<typeof FOR_BANK_SUB_SECTIONS.FOR_BANK_EXECUTIVE_SUMMARY>;
export type IForBankAboutCompanySubSections = ObjectValues<typeof FOR_BANK_SUB_SECTIONS.FOR_BANK_ABOUT_COMPANY>;
export type IForBankProductAndServicesSubSections = ObjectValues<
  typeof FOR_BANK_SUB_SECTIONS.FOR_BANK_PRODUCTS_AND_SERVICES
>;
export type IForBankManagementAndOrganization = ObjectValues<
  typeof FOR_BANK_SUB_SECTIONS.FOR_BANK_MANAGEMENT_AND_ORGANIZATION
>;
export type IForBankMarketAnalysisSubSections = ObjectValues<typeof FOR_BANK_SUB_SECTIONS.FOR_BANK_MARKET_ANALYSIS>;
export type IForBankBusinessOperationsSubSections = ObjectValues<
  typeof FOR_BANK_SUB_SECTIONS.FOR_BANK_BUSINESS_OPERATIONS
>;
export type IForBankMarketingAndSalesSubSections = ObjectValues<
  typeof FOR_BANK_SUB_SECTIONS.FOR_BANK_MARKETING_AND_SALES
>;
export type IForBankFinancialPlanSubSections = ObjectValues<typeof FOR_BANK_SUB_SECTIONS.FOR_BANK_FINANCIAL_PLAN>;

export type IForBankSubSections =
  | IForBankOverviewSubSections
  | IForBankExecutiveSummarySubSections
  | IForBankAboutCompanySubSections
  | IForBankProductAndServicesSubSections
  | IForBankManagementAndOrganization
  | IForBankMarketAnalysisSubSections
  | IForBankBusinessOperationsSubSections
  | IForBankMarketingAndSalesSubSections
  | IForBankFinancialPlanSubSections;

export const FOR_BANK_MAX_LENGTHS = {
  IMPLEMENTATION_PLAN: {
    STAGE: 150,
  },
};
